<template>
  <v-app>
    <template v-if="!login">
      <v-navigation-drawer fixed clipped v-model="drawer" width="180" app>
        <v-list dense>

          <v-list-tile v-for="(it, i) in menuOptions" :key="i" @click="$router.push({name: it.route})">
            <v-list-tile-action>
              <i class="fas" :class="it.icon"></i>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ it.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="#c4161c" dark clipped-left height="50" fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>IPOG SP</v-toolbar-title>
      </v-toolbar>
      <v-content>
        <v-container grid-list-xl fluid>
          <router-view />
        </v-container>
      </v-content>
      <v-footer color="#c4161c" app inset>
        <span style="width: 100%" class="white--text text-xs-center">&copy; IPOG SP - GESTÃO DE TURMAS. v2.0</span>
      </v-footer>
    </template>
    <template v-else>
      <v-content :style="{'background': 'url(' + require('@/assets/loginBackground.jpg') + ') center'}">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <router-view />
          </v-layout>
        </v-container>
      </v-content>
    </template>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      drawer: false,
      menuOptions: [
        { text: 'INICIO', icon: 'fa-home', route: 'dashboard' },
        { text: 'UNIDADES', icon: 'fa-map-marker-alt', route: 'units' },
        { text: 'CURSOS', icon: 'fa-graduation-cap', route: 'courses' },
        { text: 'TURMAS', icon: 'fa-book-reader', route: 'classes' },
        { text: 'SALAS', icon: 'fa-building', route: 'rooms' },
        { text: 'EQUIPE', icon: 'fa-users', route: 'users' },
        { text: 'SAIR', icon: 'fa-power-off', route: 'login' },
      ]
    }
  },
  computed: {
    login() {
      return this.$store.getters.login
    }
  },
  beforeCreate() {
    // VERIFICA SE ESTÁ LOGADO, CASO CONTRARIO REDIRECIONA PARA O LOGIN" //
    if (!localStorage.miolocat) {
      this.$router.push({name: 'login'})
    } else {
      this.$http.get('/users/logged').then(data => {
        if (data.data.active == '1') return this.$store.commit('userData', data.data)
        else return this.$router.push({name: 'login'})
      }).catch(err => {
        this.$router.push({name: 'login'})
      })
    }
  }
}
</script>

<style scoped>

</style>

